import * as Yup from 'yup';

export default function getPhoneNumberSchema(fieldName: string = 'Phone Number') {
  return Yup.string()
    .trim()
    .required(`${fieldName} is required`)
    .test({
      name: 'phone-length',
      test: (value) => {
        if (!value) return true;
        return value.length >= 10;
      },
      message: `${fieldName} must be a 10-digit US phone number.`,
    });
}
